import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {ref, watch, computed} from 'vue';



export default /*@__PURE__*/_defineComponent({
  __name: 'RatingSlider',
  props: {
  disable: {
    type: Boolean,
    default: false
  },
  direction: {
    type: String,
    default: 'horizontal'
  },
  trackSize: {
    type: String,
  },
  showTicks: {
    type: [String, Boolean],
    default: 'always'
  },
  readonly: {
    type: Boolean,
    default: false
  },
  color: {
    type: String,
    default: '#1EBCD5'
  },
  min: {
    type: Number,
    default: 1
  },
  max: {
    type: Number,
    default: 10
  }
},
  emits: ['update:modelValue'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v830fe77c": (__props.color)
}))

const emit = __emit;

const props = __props;

const rating = ref(0)

const tickLabels = computed(() => {
  const labels: Record<number, string> = {};
  for (let i = props.min; i <= props.max; i++) {
    labels[i] = i.toString();
  }
  return labels;
});

watch(rating, (newValue) => {
  emit('update:modelValue', newValue);
});

return (_ctx: any,_cache: any) => {
  const _component_v_slider = _resolveComponent("v-slider")!

  return (_openBlock(), _createBlock(_component_v_slider, {
    modelValue: rating.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((rating).value = $event)),
    ticks: tickLabels.value,
    max: __props.max,
    min: __props.min,
    step: "1",
    "tick-size": "0",
    color: __props.color,
    "track-color": "grey",
    "thumb-size": 14,
    "track-size": __props.trackSize,
    "thumb-color": "white",
    "show-ticks": __props.showTicks,
    direction: __props.direction,
    disabled: __props.disable,
    readonly: __props.readonly,
    "hide-details": ""
  }, null, 8, ["modelValue", "ticks", "max", "min", "color", "track-size", "show-ticks", "direction", "disabled", "readonly"]))
}
}

})